import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Container, Row, Col, Button } from 'react-bootstrap';
import slider1 from '../../../assets/img/sections/slider1.jpg'
import edit from '../../../assets/img/icons/edit.svg'
import silver from '../../../assets/img/premium/silver.svg'
import premium from '../../../assets/img/icons/premium.svg'
import gold from '../../../assets/img/premium/gold.svg'
import blue from '../../../assets/img/premium/blue.svg'
import profileinfo from '../../../assets/img/icons/profileinfo.svg'
import profilelocation from '../../../assets/img/icons/profilelocation.svg'
import profileheart from '../../../assets/img/icons/profileheart.svg'
import back from '../../../assets/img/icons/back.svg'
import ProfileInfo from './components/profileinfo';
import Interest from './components/interest';
import axios from 'axios';
import ls from "local-storage";
import SelectPlan from '../../main/plan/selectplan';
import PaymentPending from '../../main/plan/paymentpending';
import Location from '../../commoncomponents/location';
import Join from '../plan/join';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class Profile extends Component {

    constructor(props) {
        super(props);
        this.cancel_autorenewal = this.cancel_autorenewal.bind(this);
        this.state = {
            selectedOptions: {
                silver: false,
                gold: false,
                blue: false,
                profileinfomodal: false,
                interestmodal: false,
                selectplanmodal: false,
                locationmodal: false,
                paymentpendingmodal: false,
            },
            premiummodal: false,
            user_details: '',
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            selected_interest: [],
            selected_interest_length: '',premiumType: ''
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== false) {
                const user_details = res.data.result;
                this.setState({
                    user_details: user_details,
                    loc: user_details.location,
                    selected_interest: user_details.interest,
                });
            }
        });
    }

    toggleOption = (option, row) => {
        if (row === 'premium') {
            const updatedOptions = { ...this.state.selectedOptions };
            ['silver', 'gold', 'blue'].forEach(key => {
                updatedOptions[key] = false;
            });
            updatedOptions[option] = true;
            this.setState({
                selectedOptions: updatedOptions
            });
        } else {
            console.log('checking')
        }
    };

    handleProfileInfoOpenModal = () => {
        this.setState({ profileinfomodal: true });
    }

    handleProfileInfoCloseModal = () => {
        this.setState({ profileinfomodal: false });
    }

    handleInterestOpenModal = () => {
        this.setState({ interestmodal: true });
    }

    handleInterestCloseModal = () => {
        this.setState({ interestmodal: false });
    }

    handleSelectPlanOpenModal = (option, row) => {
        if(this.state.user_details.premium_cashpayment === 'true') {
            this.handlePaymentPendingOpenModal();
        } else {
            if (row === 'premium') {
                this.setState({
                    premiumType: option
                });
            } else {
                console.log('else')
            }
            this.setState({ selectplanmodal: true });
        }
    }

    handleSelectPlanCloseModal = () => {
        this.setState({ selectplanmodal: false });
    }

    handleLocationOpenModal = () => {
        if(this.state.user_details.premium_member == "true"){
            this.setState({ locationmodal: true });
        }else{
            this.setState({ premiummodal: true });
        }
    }

    handleLocationCloseModal = () => {
        this.setState({ locationmodal: false });
    }

    handlePremiumCloseModal = () => {
        this.setState({ premiummodal: false });
    }

    handlePaymentPendingOpenModal = () => {
        this.setState({ paymentpendingmodal: true });
    }

    handlePaymentPendingCloseModal = () => {
        this.setState({ paymentpendingmodal: false });
    }

    cancel_autorenewal(){
        var payment = new FormData();
        payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        payment.set('subscription_id', this.state.user_details.subscription_id);
        axios({
            method: 'post', 
            url: this.state.api_url+'cancelautorenewal',
            data: payment, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if (res.data.status === "true") {
                this.setState({
                    successMessage: 'Cancelled Auto-renewal',
                    suc_cls: 'successMsg floatingAlerts1',
                });
                setTimeout(() => {
                    this.setState({
                        suc_msg: 'successMsghide'
                    });
                    window.location.reload();
                }, 2000);
            }else{
                this.setState({
                    successMessage: "Something went wrong",
                    suc_cls: 'errorMsg floatingAlerts1',
                });
                setTimeout(() => {
                    this.setState({
                        suc_msg: 'errorMsghide'
                    });
                    window.location.reload();
                }, 2000);
            }   
        })
    }

    render() {
        const { selectedOptions, user_details } = this.state;
        console.log("PROFILE STATE: ", user_details);
        return (
            <>
                <section className='common_layout'>
                    <div className='header_layout'>
                        <div className='header_title margin_auto'>
                            <h4><Trans i18nKey="Profile">Profile</Trans></h4>
                        </div>
                        <div className='whole_information'>
                            {this.state.successMessage && (
                                <div className={this.state.suc_cls}>
                                    {this.state.successMessage}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='mt_2'>
                        <Container>
                            <Row className=''>
                                <Col md={8} sm={4} className="margin_xauto">
                                    <div className='profile_Section'>
                                        <div className='profile_card premiumprofile_card'>
                                            <div className='profile_card_img'>
                                                <img src={this.state.user_details.images} alt="img" />
                                            </div>
                                            <div className='profile_card_content'>
                                                {
                                                    (user_details.premium_member !== null && user_details.premium_member !== '' && user_details.premium_member === "false") 
                                                    ?
                                                    <div className='premiumprofile_div'>
                                                        <div>
                                                            <h4>{this.state.user_details.user_name}, {this.state.user_details.age}</h4>
                                                        </div>
                                                    </div> 
                                                    : 
                                                    <div className='premiumprofile_div'>
                                                        <div>
                                                            <h4>{this.state.user_details.user_name}, {this.state.user_details.age}</h4>
                                                            <img src={premium} alt="img" />
                                                        </div>
                                                        <p><Trans i18nKey="Your premium membership will expire on">Your premium membership will expire on</Trans> {user_details.membership_valid_web1}</p>
                                                    </div>
                                                }
                                                <Button className="">
                                                    <Link to='/editphoto'>
                                                        <img src={edit} alt="img" />
                                                        Edit
                                                    </Link>
                                                </Button>
                                            </div>
                                        </div>

                                        {/* cancel_autorenewal */}
                                        {this.state.user_details.premium_member === 'true' && this.state.user_details.payment_method === 'stripe' && this.state.user_details.stripe_status !== 'cancel_autorenewal' && (
                                            <div className='profile_card_content' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                <div className='cancelauto'>
                                                    <Button className="button" onClick={this.cancel_autorenewal}>
                                                        <Trans i18nKey="Cancel Auto-renewal">Cancel Auto-renewal</Trans>
                                                    </Button>
                                                </div>
                                            </div>
                                        )}

                                        {(user_details.premium_member !== null && user_details.premium_member !== '' && user_details.premium_member === "false") ? 
                                        <div className='premium_section'>
                                            <h4 className='premium_title'></h4>
                                            <div className='profile_premium'>
                                                <>
                                                    <div className={`profile_premium_div ${selectedOptions.silver ? 'profliepremiumselect' : ''}`} onClick={() => this.handleSelectPlanOpenModal('silver', 'premium')}>
                                                        <div className='profile_premium_subdiv'>
                                                            <img src={silver} alt="img" />
                                                            <h4><Trans i18nKey="Kaba Silver">Kaba Silver</Trans></h4>
                                                        </div>
                                                    </div>
                                                    <div className={`profile_premium_div ${selectedOptions.gold ? 'profliepremiumselect' : ''}`} onClick={() => this.handleSelectPlanOpenModal('gold', 'premium')}>
                                                        <div className='profile_premium_subdiv'>
                                                            <img src={gold} alt="img" />
                                                            <h4><Trans i18nKey="Kaba Gold">Kaba Gold</Trans></h4>
                                                        </div>
                                                    </div>
                                                    <div className={`profile_premium_div ${selectedOptions.platinum ? 'profliepremiumselect' : ''}`} onClick={() => this.handleSelectPlanOpenModal('platinum', 'premium')}>
                                                        <div className='profile_premium_subdiv'>
                                                            <img src={blue} alt="img" />
                                                            <h4><Trans i18nKey="Kaba Platinum">Kaba Platinum</Trans></h4>
                                                        </div>
                                                    </div>
                                                </>
                                            </div>
                                        </div> : ''}
                                                         
                                        <div className='profile_details_card'>
                                            <div className='profiledetails_card_subdiv' onClick={this.handleProfileInfoOpenModal}>
                                                <div className='profiledetails_card_left'>
                                                    <img src={profileinfo} alt="img" />
                                                    <h4><Trans i18nKey="Information">Information</Trans></h4>
                                                </div>
                                                <div className='profiledetails_card_right'>
                                                    <p className='text-truncate'>{this.state.user_details.user_name}</p>
                                                    <img src={back} alt="img" />
                                                </div>
                                            </div>
                                            <div className='profiledetails_card_subdiv' onClick={this.handleInterestOpenModal}>
                                                <div className='profiledetails_card_left'>
                                                    <img src={profileheart} alt="img" />
                                                    <h4>{this.state.user_details.ex1} <Trans i18nKey="Interest">Interest</Trans></h4>
                                                </div>
                                                <div className='profiledetails_card_right'>
                                                    <p className='text-truncate'>{this.state.user_details.interest1}</p>
                                                    <img src={back} alt="img" />
                                                </div>
                                            </div>
                                            <div className='profiledetails_card_subdiv' onClick={this.handleLocationOpenModal}>
                                                <div className='profiledetails_card_left'>
                                                    <img src={profilelocation} alt="img" />
                                                    <h4><Trans i18nKey="Location">Location</Trans></h4>
                                                </div>
                                                <div className='profiledetails_card_right'>
                                                    <p className='text-truncate'>{this.state.loc}</p>
                                                    <img src={back} alt="img" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section>

                <ProfileInfo
                    showModal={this.state.profileinfomodal}
                    handleClose={this.handleProfileInfoCloseModal}
                />

                <Interest
                    showModal={this.state.interestmodal}
                    handleClose={this.handleInterestCloseModal}
                />

                <SelectPlan
                    showModal={this.state.selectplanmodal}
                    handleClose={this.handleSelectPlanCloseModal}
                    premiumType={this.state.premiumType}
                />

                <Location
                    showModal={this.state.locationmodal}
                    handleClose={this.handleLocationCloseModal}
                />

                <PaymentPending
                    showModal={this.state.paymentpendingmodal}
                    handleClose={this.handlePaymentPendingCloseModal}
                />

                <Join
                    showModal={this.state.premiummodal}
                    handleClose={this.handlePremiumCloseModal}
                />
            </>
        );
    }
}

export default withTranslation("translations")(Profile);